// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* sidebar */
/* .sidebar {
  background-color: #3e3e3e;
  max-width: 15rem;
}
.sidebar .nav {
  padding: 0px !important;
}

.sidebar ul li a:hover {
  background-color: blue;
}

.carrot-page {
  background-color: #3e3e3e;
}
.page-container {
  flex-grow: 1;
  background-color: white;
}
.main {
  display: flex;
} */

.main-color {
  background-color: #3e3e3e;
}
.page-container {
  background-color: #f9f9f9;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,YAAY;AACZ;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* sidebar */\n/* .sidebar {\n  background-color: #3e3e3e;\n  max-width: 15rem;\n}\n.sidebar .nav {\n  padding: 0px !important;\n}\n\n.sidebar ul li a:hover {\n  background-color: blue;\n}\n\n.carrot-page {\n  background-color: #3e3e3e;\n}\n.page-container {\n  flex-grow: 1;\n  background-color: white;\n}\n.main {\n  display: flex;\n} */\n\n.main-color {\n  background-color: #3e3e3e;\n}\n.page-container {\n  background-color: #f9f9f9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
